<template>
    <b-navbar toggleable="md">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-collapse is-nav id="nav_collapse">
            <b-navbar-brand href="#">
                <img src="../assets/logoVersa.png" alt="Logo" width="80">
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown right>
                    <template slot="button-content">
                        <em>{{currentLanguage}}</em>
                    </template>
                    <b-dropdown-item v-for="(lang, i) in languages" :key="`Lang${i}`" :value="lang" @click="$i18n.locale = lang.code">{{ lang.name }}</b-dropdown-item>
                </b-nav-item-dropdown>

                 <b-nav-item-dropdown right>
                    <template slot="button-content">
                        <em>{{ currentUser.email}}</em>
                    </template>
                    <b-dropdown-item href="#/profile"> {{ $t("messages.nav.profile") }}
                    
                    </b-dropdown-item>
                    <b-dropdown-item @click="logout"> {{ $t("messages.nav.logout") }}</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
const fb = require('../firebaseConfig.js')
import { mapState } from 'vuex'

export default {
    computed: {
        currentLanguage: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            return this.languages[index].name;
        },
        ...mapState(['languages', 'currentUser'])
    },
    methods: {
        logout() {
            fb.auth.signOut().then(() => {
                this.$store.dispatch('clearData')
                this.$router.push('/login')
            }).catch(err => {
                console.log(err)
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/Navigation.vue